import { OcorrenciaEmpresaFormModel } from "../modelos/ocorrenciaEmpresa/ocorrenciaEmpresaFormModel";

export const OCORRENCIA_EMPRESA_FORM_INITIAL_STATE: OcorrenciaEmpresaFormModel = {
  idOcorrencia: "",
  idsEmpresas: new Array<string>(),
  ativo: true,
  };
  